"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CAM", {
  enumerable: true,
  get: function () {
    return _CAM.default;
  }
});

var _CAM = _interopRequireDefault(require("./CAM"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }